/*jshint esversion: 6 */
import { inject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import {AuthService} from '../../services/authService';
import {UserMessageService} from '../../services/userMessageService';
import {EnvironmentService} from '../../services/environmentService';
import { AccountAdminAPI } from '../../services/admin/accountAdminAPI';

@inject(AuthService, UserMessageService, Router, AccountAdminAPI, EnvironmentService)
export class Users {
  constructor(authService, userMessageService, router, api, envService) {
    this.authService = authService;
    this.userMessageService = userMessageService;
    this.router = router;
    this.api = api;
    this.envService = envService;

    this.searchTemp = null;
    this.search = null;
    this.magnfi_only = false;
  }

  limitPages = [
    { id: 10, name: '10' },
    { id: 50, name: '50' },
    { id: 100, name: '100' },
  ];

  

  activate(params) {
    if(params.whitelabel_id) {
      this.whitelabel_id = params.whitelabel_id;
    }
    if(params.account_owner_id){
      this.account_owner_id = params.account_owner_id;

    }
    this.dataList = null;
    this.count = null;
    this.limit = 10;
    this.page = 1;
    this.sortBy = 'EMAIL';
    this.sortDir = 'ASC';
    this.selectedlimitPages = 10;

    this.load();
  }

  load() {
    this.api.getUserList(
            this.search,
            this.magnfi_only ? "NONE" : this.whitelabel_id,
            this.page,
            this.limit,
            this.sortBy,
            this.sortDir,
            this.authService.getUser().token,
            this.saveLoadSuccess.bind(this),
            this.saveLoadError.bind(this));
  }


  saveLoadSuccess(data) {
    this.setData(data);
  }

  saveLoadError(msg) {
    this.userMessageService.setUserError('user', msg);
  }

  setData(data) {
    this.dataList = data.list;
    this.count = data.count;
    this.pages =  Math.floor(this.count / this.limit);
    this.pages = this.pages * this.limit <= this.count ? this.pages + 1 : this.pages;
  }

  rowClicked(item) {
    this.router.navigate((this.whitelabel_id?'#/wladmin/whitelabel/'+this.whitelabel_id+'/':'')+'user/' + item.id);
  }

  columnClicked(name) {
    $( ".sorting" ).removeClass( "sorting_asc" );
    $( ".sorting" ).removeClass( "sorting_desc" );
    if (this.sortBy == name) {
      if (this.sortDir == 'ASC') {
        this.sortDir = 'DESC';
        $( "#"+name ).addClass( "sorting_desc" );
      } else {
        this.sortDir = 'ASC';
        $( "#"+name ).addClass( "sorting_asc" );
      }

      this.load();
    } else {
      this.sortBy = name;
      this.sortDir = 'DESC';
      $( "#"+name ).addClass( "sorting_desc" );
      this.load();
    }
  }

  prev() {
    if (this.page > 1) {
      this.page--;
      this.dataList = null;
      this.load();
    }
  }

  next() {
    if (this.page < this.pages) {
      this.page++;
      this.dataList = null;
      this.load();
    }
  }

  limitChange() {
    console.log("event called",this.selectedlimitPages);
    if(this.limit != this.selectedlimitPages){
    this.limit = this.selectedlimitPages;
    this.dataList = null;
    this.load();
    }
  }

  handleKeypress(event) {
    if (event.keyCode == 13) {
      this.search = this.searchTemp;
      this.load();
      //event.preventDefault();
      return false;

    }

    return true;
  }

}
